const employees = 'employees';

export default {
  employees,
};
